import { InjectedOptions, useMutation } from "@oysterhr/core"
import { gql } from "../../../gql"
import {
  StaffCancelTerminationMutation,
  StaffCancelTerminationMutationVariables,
} from "../../../gql/graphql"

export const CANCEL_TERMINATION_MUTATION = gql(`
  mutation StaffCancelTermination($terminationId: ID!, $cancelReason: String!) {
    cancelTermination(input: { terminationId: $terminationId, cancelReason: $cancelReason }) {
      errors
    }
  }
`)

export const useCancelTermination = (
  options?: InjectedOptions<
    StaffCancelTerminationMutation,
    StaffCancelTerminationMutationVariables
  >,
) => useMutation(CANCEL_TERMINATION_MUTATION, options)
